import { Component, HostListener, Input, OnDestroy } from '@angular/core';
import { MessagesService } from '../message/messages.service';
import { CurrentUser } from "../../common/providers/current-user";
import { Snackbar } from '../../common/snackbar/snackbar';
import { ShareParticipantDialogComponent } from './share-participant-dialog.component';
import { TextMessage } from '../message/text-message.model';
import { DiscussionService } from '../discussion/discussion.service';
import { DiscussionModel } from '../../common/models/discussion-model';
import { ConfigProvider} from "../../config-provider.service";
import { SnackbarData } from '../../common/snackbar/snackbar-data';
import { ShareService } from './share.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Organization } from "../../common/models/organization";
import { ChatSharableInterface } from "../../common/models/chat-sharable-interface";
import { User } from "../../common/models/user";
import { Exercice } from "../../common/models/exercice";
import { Session } from "../../common/models/session";

@Component({
  selector: 'app-chat-share',
  template: '<ng-content></ng-content>',
  standalone: true,
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnDestroy {
    @Input()
    public organization: Organization | null = null;

    @Input()
    public sessionId: number | null = null;

    @Input()
    public sharable: ChatSharableInterface = {} as ChatSharableInterface;
    public user: User | null = null;
    private subscriptions: Subscription[] = [];

    constructor(
        private messagesService: MessagesService,
        private discussionService: DiscussionService,
        private currentUser: CurrentUser,
        private snackbar: Snackbar,
        private shareParticipantDialog: MatDialog,
        private conf: ConfigProvider,        private shareService: ShareService
    ) {
        this.user = currentUser.user;

    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    @HostListener('click', ['$event.target'])
    public onClick(target:any) {
        const dialog: MatDialogRef<ShareParticipantDialogComponent> = this.shareParticipantDialog.open(ShareParticipantDialogComponent, {
            data: {
                user: this.user,
                organization: this.organization,
            }
        });

        this.subscriptions.push(
            dialog.afterClosed().subscribe((selectedUsersId: number[] = []) => {
                if (selectedUsersId.length <= 0) {
                    return;
                }

                this.subscriptions.push(
                    this.discussionService.findDiscussionsBetweenTwoUsers(this.user?.id!, selectedUsersId, this.organization!).subscribe((discussions: DiscussionModel[]) => {
                        discussions.forEach((discussion) => {
                            if (!this.user?.id || !this.organization || !this.sharable) throw new Error('Missing user, organization or sharable');
                            this.subscriptions.push(
                                this.messagesService.sendTextMessage(this.user.id, discussion.id!, {
                                    message: `${this.sharable.chatSharableName()} : ${this.conf.appUrl}${this.organization!.code}/${this.sharable.chatSharableType()}/${this.sharable.chatSharableId()}`,
                                    linkTitle: this.sharable.chatSharableName(),
                                    linkUrl: this.organization!.code + '/' + this.sharable.chatSharableType() + '/' + this.sharable.chatSharableId() + (this.sessionId ? '?session=' + this.sessionId : ''),
                                }).subscribe({
                                    next: (message: TextMessage) => {
                                      this.shareService.sharedEvent.emit();

                                      const data = new SnackbarData('ChatLinkShared');
                                      this.snackbar.show(data);
                                    },
                                    error: (error: any) => {
                                      const data = new SnackbarData('ChatLinkNotShared');
                                      this.snackbar.show(data);
                                    }
                                })
                            );
                        });
                    })
                );
            })
        );
    }
}
